/**
 * 客製化 chakra-ui toast UI
 * 因為若直接使用 toast 會與官方 default UI 不一樣，推測是受其它 UI library 影響(如 antd)
 */

import { Box, Flex, Heading, CloseButton } from '@chakra-ui/react';
import { CheckCircleIcon, WarningIcon, InfoIcon } from '@chakra-ui/icons';

export const RenderedToast = ({
  id,
  title = '',
  iconSize = 18,
  status = 'info',
  description = '',
  onClose = null,
  handleClose = null,
  isClosable = true,
}) => {
  let icon = null;
  let backgroundColor = 'green.500';

  const lowerStatus = status.toLowerCase();

  switch (lowerStatus) {
    case 'success':
      icon = <CheckCircleIcon w={iconSize} h={iconSize} />;
      backgroundColor = 'green.500';
      break;
    case 'info':
      icon = <InfoIcon w={iconSize} h={iconSize} />;
      backgroundColor = 'blue.500';
      break;
    case 'error':
      icon = <WarningIcon w={iconSize} h={iconSize} />;
      backgroundColor = 'red.500';
      break;
    case 'warning':
      icon = <WarningIcon w={iconSize} h={iconSize} />;
      backgroundColor = 'orange.500';
      break;
    default:
      icon = <InfoIcon w={iconSize} h={iconSize} />;
  }

  return (
    <Box id={id} color="white" p="15px" bg={backgroundColor} pos="relative" borderRadius="5px">
      <Flex direction="row">
        {icon}
        <Box pl="10px" pr="30px">
          {title && (
            <Heading as="h3" fontSize="md" color="white" fontWeight="700">
              {title}
            </Heading>
          )}
          {description && <Box pt="14px">{description}</Box>}
        </Box>
      </Flex>
      {isClosable && (
        <CloseButton
          onClick={() => {
            onClose();
            handleClose && handleClose();
          }}
          border="none"
          bgColor="transparent"
          pos="absolute"
          right="5px"
          top="5px"
        />
      )}
    </Box>
  );
};
